module.exports = function(app) {
	app.directive('eprSummaryActions', [function() {
		return {

			restrict: 'A',
			replace: false,
			template: require('directives/employee/eprSummaryActions.html'),

			scope: {
				employee: '=eprSummaryActions',
				groupNumber: '=?'
			},

			controller: ['$scope', '$rootScope', '$state', '$window', 'sessionData', 'modal', 'services', 'employee', 'planAdmin', 'coremetrics', 'coverageBuddy','$timeout','storage',
				function($scope, $rootScope, $state, $window, sessionData, modal, services, employee, planAdmin, coremetrics, coverageBuddy,$timeout, storage) {


					var UMI = $scope.employee.umi || $scope.employee.data.umi;
					var GROUP_NUMBER = $scope.employee.groupNumber || $scope.groupNumber;


					var actions = [ // these can have EITHER an sref OR a method - if you have both it'll show up twice
						{
							label: 'Edit Employee Record',
							brands: [],
							entitlements: 'isActive && entitlements.clientStatus.active && entitlements.employees.edit',
							method: goToEditEmployee
						},
						{
							label: 'Change PCP',
							brands: [],
							entitlements: 'isActive && entitlements.clientStatus.active && entitlements.employees.edit && sessionData.employerInfo.brandName!="6012"',
							method: doChangePcp
						},
						{
							label: 'Print Employee Summary',
							brands: [],
							entitlements: 'entitlements.employees.view',
							method: printSummary
						},
						{
							label: 'Manage Spending Acct Elections',
							brands: [
								'3001', '6001', '6002', '6003', '6004', '6005', '6006', '6007', '9001', '9002', '9003',
								'9004', '9005', '9006', '9007', '9008', '9009', '9010', '9011', '9012', '6008', '6009', '9015', '9017', '9018'
							],
							entitlements: 'hasGroupLevelSpending && (sessionData.entitlements.spending.spendingAccountAccess || entitlements.spending.claimsView || entitlements.spending.claimsViewNew || entitlements.spending.noClaimsView)',
							method: launchSPAModal
						},
						{
							label: 'Claims',
							brands: [],
							entitlements: 'entitlements.claims',
							method: goToClaims
						},
						{
							label: 'ID Cards',
							brands: [],
							entitlements: 'isActive && entitlements.clientStatus.active && entitlements.employees.view',
							method: goToIdCards
						},
						{
							label: 'Cancel Coverage',
							brands: [],
							entitlements: 'isActive && entitlements.clientStatus.active && entitlements.employees.edit',
							method: cancelCoverage
						},
						{
							label: 'Reinstate',
							brands: [],
							entitlements: 'isCancelled && entitlements.clientStatus.active && entitlements.employees.edit',
							method: doReinstate
						},
						{
							label: 'View SBC',
							brands: ['6008', '6009'],
							entitlements: '',
							method: doViewSbc
						}
					];


					var brandFilter = function(action, brandName) {
						if (!action.brands.length) {
							return true;
						}
						brandName = brandName || '';
						return action.brands.some(
							function(b) { return b.toLowerCase() === brandName.toLowerCase(); }
						);
					};

					var isActive = $scope.employee.status // used in eval - DO NOT DELETE
						? $scope.employee.status.toLowerCase() === 'active'
						: coverageBuddy.hasActiveGroups(employee.data.subscriber);

					var isCancelled = !isActive; // jshint ignore:line

					var allGroupNumbers;
					if (Array.isArray($scope.employee.activeGroupNumbers) || Array.isArray($scope.employee.cancelledGroupNumbers)) {
						allGroupNumbers = ($scope.employee.activeGroupNumbers || []).concat($scope.employee.cancelledGroupNumbers || []);
					}
					else {
						allGroupNumbers = coverageBuddy.getAllGroupNumbers($scope.employee.data.subscriber);
					}

					var entitlementFilter = function(action, entitlements /* used in eval - DO NOT DELETE */) { // jshint ignore:line
						if (!action.entitlements.length) { return true; }

						var groupLevelEntitlements = sessionData.employerInfo.planAdministratorEntitlements.groupLevelEntitlements;
						var hasGroupLevelSpending;
						if (allGroupNumbers) {
							for (var i = 0; i < allGroupNumbers.length; ++i) {
								var groupNumber = allGroupNumbers[i];
								if (
									groupLevelEntitlements &&
									groupLevelEntitlements[groupNumber] &&
									groupLevelEntitlements[groupNumber]['Spending Account']
								) {
									hasGroupLevelSpending = true;
									break;
								}
							}
						}
						return eval(action.entitlements); // jshint ignore:line
					};

					$scope.actions = actions.filter(
						function(action) {
							return brandFilter(action, sessionData.employerInfo.brandName) && entitlementFilter(action, sessionData.entitlements);
						}
					);

					$scope.click = function(label) {
						var buttonAction = function() {};
						for (var i = 0; i < $scope.actions.length; ++i) {
							if (label === $scope.actions[i].label) {
								buttonAction = $scope.actions[i].method;
								$scope.showActions = !$scope.showActions;
								if(label == "Edit Employee Record"){
									if($state.current.name == "employee.find"){
										 coremetrics.startConversion('EMPLOYERS:ENROLLMENT: EDIT EMPLOYEE:SEARCH RESULTS','EMPLOYERS:ENROLLMENT');
									}else if($state.current.name == "employee.find.review"){
										coremetrics.startConversion('EMPLOYERS:ENROLLMENT:EDIT EMPLOYEE:SUBSCRIBER SUMMARY','EMPLOYERS:ENROLLMENT');
									}
									coremetrics.pageviewTag('EMPLOYERS:ENROLLMENT:EDIT EMPLOYEE','EMPLOYERS:ENROLLMENT');
								}
								break;
							}
						}
						buttonAction();
					};

					var prepareAndPopModalForChgPcpAndViewSbc = function(isForSbc) {
						var activeGroupNumbers;
						if ($scope.employee.data && $scope.employee.data.subscriber) {
							activeGroupNumbers = coverageBuddy.getActiveGroupNumbers($scope.employee.data.subscriber);
						}
						else {
							activeGroupNumbers = $scope.employee.activeGroupNumbers || [];
						}
						var pcpModalScope = $rootScope.$new();
						pcpModalScope.isForSbc = isForSbc;
						pcpModalScope.umi = UMI;
						pcpModalScope.activeGroupNumbers = activeGroupNumbers;
						pcpModalScope.groupNumber = GROUP_NUMBER;

						employee.loadSummary(UMI).then(function() {
							modal.open({
								template: require('pages/employee/modals/change-pcp-modal.html'),
								controller: require('pages/employee/modals/change-pcp-modal.js'),
								scope: pcpModalScope
							});
						});
					};

					function doViewSbc() {
						var activeGroupNumbers = $scope.employee.data && $scope.employee.data.subscriber ?
							coverageBuddy.getActiveGroupNumbers($scope.employee.data.subscriber) :
							$scope.employee.activeGroupNumbers || [];
						var sbcScope = $rootScope.$new();
						sbcScope.umi = UMI;
						sbcScope.activeGroupNumbers = activeGroupNumbers;
						sbcScope.groupNumber = GROUP_NUMBER;

						modal.open({
							template: require('pages/employee/modals/downloadSbcModal.html'),
							controller: require('pages/employee/modals/downloadSbcModal.js'),
							scope: sbcScope
						});
					}

					function launchSPAModal() {
						switch ($state.current.name) {
							case 'employee.find':
								coremetrics.elementTag('FIND EMPLOYEE MANAGE SPENDING ACCOUNT ELECTIONS', 'EMPLOYERS:ENROLLMENT');
								break;
							case 'employee.find.review':
								coremetrics.elementTag('VIEW SUMMARY MANAGE SPENDING ACCOUNT ELECTIONS', 'EMPLOYERS:ENROLLMENT');
								break;
							default:
								break;
						}
						var spaModalScope = $rootScope.$new();
						spaModalScope.umi = UMI;
						spaModalScope.allGroupNumbers = allGroupNumbers;

						employee.loadSummary(UMI).then(function() {
							modal.open({
								template: require('pages/employee/modals/manage-spa-election.html'),
								controller: require('pages/employee/modals/manage-spa-election'),
								scope: spaModalScope
							});
						});
					}

					function cancelCoverage() {
						switch ($state.current.name) {
							case 'employee.find':
								coremetrics.startConversion('EMPLOYERS:ENROLLMENT:CANCEL COVERAGE:SEARCH RESULTS', 'EMPLOYERS:ENROLLMENT');
								coremetrics.elementTag('FIND EMPLOYEES CANCEL COVERAGE', 'EMPLOYERS:ENROLLMENT:FIND EMPLOYEE SEARCH RESULTS');
								break;
							case 'employee.find.review':
								coremetrics.startConversion('EMPLOYERS:ENROLLMENT:CANCEL COVERAGE:SUBSCRIBER SUMMARY', 'EMPLOYERS:ENROLLMENT');
								coremetrics.elementTag('VIEW SUMMARY CANCEL COVERAGE', 'EMPLOYERS:ENROLLMENT');
								break;
							default:
								break;
						}
						var activeGroupNumbers;
						if ($scope.employee.data && $scope.employee.data.subscriber) {
							activeGroupNumbers = coverageBuddy.getActiveGroupNumbers($scope.employee.data.subscriber);
						}
						else {
							activeGroupNumbers = $scope.employee.activeGroupNumbers || [];
						}

						if (activeGroupNumbers.some(planAdmin.canModifyGroupNumber)) {
							return $state.go('employee.cancelCoverage', { umi: UMI });
						}
						else {
							$scope.modalContent = {
								header: 'Access Denied',
								message: 'You do not have permission to modify any active groups.'
							};
							modal.open({
								template: require('pages/employee/modals/genericInfoModal.html'),
								scope: $scope
							});
						}
					}

					function doChangePcp() {
						switch ($state.current.name) {
							case 'employee.find':
								coremetrics.elementTag('FIND EMPLOYEE CHANGE PCP', 'EMPLOYERS:ENROLLMENT');
								break;
							case 'employee.find.review':
								coremetrics.elementTag('VIEW SUMMARY CHANGE PCP', 'EMPLOYERS:ENROLLMENT');
								break;
							default:
								break;
						}
						prepareAndPopModalForChgPcpAndViewSbc(false);  // false means this is NOT for View SBC
					}

					function printSummary() {
						switch ($state.current.name) {
							case 'employee.find':
								coremetrics.elementTag('FIND EMPLOYEE PRINT', 'EMPLOYERS:ENROLLMENT');
								storage.set('thisUmi', UMI);
								//$state.go('employee.find.review', ({ umi: UMI, print: false }));
								//$scope.$emit('switchToFindPrintMode');
								var printMode = true;
								var url = window.location.href+"/review?print="+printMode;
								var printWindow = window.open( url,"_blank","top=100,left=100,width=800,height=500");
							    /*printWindow.onload = function() {
								setTimeout(function(){
									printWindow.focus();
									printWindow.print();
									printWindow.close();
								},100);*/
								break;
							case 'employee.find.review':
								coremetrics.elementTag('VIEW SUMMARY PRINT', 'EMPLOYERS:ENROLLMENT');
								$scope.$emit('switchToPrintMode');
								break;
							default:
								break;
						}

					}

					function doReinstate() {
						switch ($state.current.name) {
							case 'employee.find':
								coremetrics.startConversion('EMPLOYERS:ENROLLMENT:REINSTATE EMPLOYEE','EMPLOYERS:ENROLLMENT');
								coremetrics.elementTag('FIND EMPLOYEE REINSTATE', 'EMPLOYERS:ENROLLMENT:FIND EMPLOYEE SEARCH RESULTS');
								break;
							case 'employee.find.review':
								coremetrics.elementTag('VIEW SUMMARY REINSTATE', 'EMPLOYERS:ENROLLMENT');
								break;
							default:
								break;
						}
						$scope.asoValue = sessionData.entitlements.clientQualifiers.aso;
						$scope.reinstateCoverageEffectiveDate = null;
						var openReinstateModal = function() {
							modal.open({
								template: require('pages/employee/modals/reinstateCoverageModal.html'),
								scope: $scope,
								classes: 'epr-standard-modal'
							});
						};
						openReinstateModal();
					}

					$scope.reinstateCoverage = function () {
						if ($state.current.name == 'employee.find') {
							coremetrics.elementTag('REINSTATE COVERAGE', 'EMPLOYERS:ENROLLMENT');
						}
						$scope.closeModal();
                        storage.set('ReinstateValue', 'true');
						$state.go('employee.add.subscriber', { umi: UMI, reinstateDate: $scope.reinstateCoverageEffectiveDate });
					};

					function goToClaims() {
						switch ($state.current.name) {
							case 'employee.find':
								coremetrics.elementTag('FIND EMPLOYEES CLAIMS', 'EMPLOYERS:ENROLLMENT');
								break;
							case 'employee.find.review':
								coremetrics.elementTag('VIEW SUMMARY CLAIMS', 'EMPLOYERS:ENROLLMENT');
								break;
							default:
								break;
						}
						$state.go('claims', { umi: UMI });
					}

					function goToIdCards() {
						switch ($state.current.name) {
							case 'employee.find':
								coremetrics.elementTag('FIND EMPLOYEE ID CARDS', 'EMPLOYERS:ENROLLMENT');
								break;
							case 'employee.find.review':
								coremetrics.elementTag('VIEW SUMMARY ID CARDS', 'EMPLOYERS:ENROLLMENT');
								break;
							default:
								break;
						}
						$state.go('assistEmployees.idCards', { umi: UMI });
					}

					function displaySvcError() {
						$scope.stopEditSvcError = {
							svcFailed: true,
							errorMsg: 'An error has occurred while processing your transaction. Please try again. If the problem persists, please call Customer Service.'
						};

						modal.open({
							template: require('pages/employee/modals/modalStopEditDueToPendingTransactions.html'),
							controller: require('pages/employee/modals/modalStopEditDueToPendingTransactions.js'),
							scope: $scope
						});
					}

					$scope.stopEditSvcError = { svcFailed: false, errorMsg: '' };

					function goToEditEmployee() {
						switch ($state.current.name) {
							case 'employee.find':
								coremetrics.elementTag('FIND EMPLOYEE EDIT EMPLOYEE', 'EMPLOYERS:ENROLLMENT');
								break;
							case 'employee.find.review':
								coremetrics.elementTag('VIEW SUMMARY EDIT EMPLOYEE', 'EMPLOYERS:ENROLLMENT');
								break;
							default:
								break;
						}

						employee.metadata.getEnrollmentsIsRunning = true;
						employee.loadSummary(UMI).then(
							function(e) {
								if (
									e.data.subscriber.ssn
								) {
									if (planAdmin.hasModifiableData(e.data)) {
										services.eprsvc.enrollments().check(e.data.subscriber.ssn).then(
											function(hasPendingTransactions) {
												employee.metadata.getEnrollmentsIsRunning = false;
												if (hasPendingTransactions) {
													modal.open({
														template: require('pages/employee/modals/pendingTransaction.html'),
														classes: 'epr-standard-modal'
													});
												}
												else {
													if ($state.current.name === 'employee.find.review') {
														$scope.$emit('switchToEditMode');
													}
													else {
														$state.go('employee.find.review', { umi: UMI, edit: true });
													}
												}
											},
											function() {
												employee.metadata.getEnrollmentsIsRunning = false;
												displaySvcError();
											}
										);
									}
									else {
                                        employee.metadata.getEnrollmentsIsRunning = false;
										modal.open({
											template: require('pages/employee/modals/modalPaDoesNotHaveModify.html'),
											controller: require('pages/employee/modals/modalPaDoesNotHaveModify.js'),
											scope: $scope
										});
									}
								}
							},
							function() {
								employee.metadata.getEnrollmentsIsRunning = false;
								displaySvcError();
							}
						);
					}
				}
			]
		};
	}]);
};
